import React, { PropsWithChildren } from 'react';
import Typography, { TypographyProps } from '@material-ui/core/Typography';
import withThemeProvider from '../util/withThemeProvider';

/**
 *
 * @deprecated use `<Text>` from jigsaw
 */
const SolvTypography = ({ children, ...rest }: PropsWithChildren<TypographyProps>) => (
  <Typography {...rest}>{children}</Typography>
);

export default withThemeProvider(SolvTypography);
